module.exports = __webpack_public_path__ + "img/89.67d5b0c1.png";